import React, {useContext, useEffect, useRef, useState} from 'react';
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import PrintDataComponent from "./PrintDataComponent";
import {SharedContext} from "../../Pages";
import {data} from "./printerData";
import {printProperties} from "./printProperties";
import {getWidthHeightSize} from "./printerFunctions";

const Printer = () => {
  const [sharedDataState, setSharedDataState] = useState({});
  const [widthHeightSizeFromSizeTitle, setWidthHeightSizeFromSizeTitleFromSizeTitle] = useState({})

  const myRef = useRef();

  const mySharedContext = useContext(SharedContext);

  let sharedData = {...mySharedContext.state}
  sharedData = {type: "print", data: data}

  if (!sharedData.data.sizeTitle) {
    sharedData.data.sizeTitle = 'A5'
  }
  if (!sharedData.data.orientation) {
    sharedData.data.orientation = 'landscape'
  }
  useEffect(() => {

    const temp = getWidthHeightSize(sharedData, printProperties);

    setWidthHeightSizeFromSizeTitleFromSizeTitle(temp)


    setSharedDataState(sharedData)
  }, [sharedDataState.data?.sizeTitle])


  const sizeClickHandler = (size) => {
    const temp = {...sharedDataState}
    temp.data.sizeTitle = size.title;
    setSharedDataState(temp)
  }
  return (<>
    {Object.keys(sharedDataState).length === 0 ? <> در حال بارگزاری</> :
      <div className={"printBalanceBenefit"} style={{width: "100%", height: "75vh", overflow: "scroll"}}>
        <div>
          <div className={"d-flex justify-content-center align-items-center"}>
            {printProperties.map((singleRow, index) => {

              // console.log(singleRow)

              // اینجا بک اند به عنوان سایز میفرسته بعدش ما توی آرایه ی سایز هامون با مقدار عنوان مقایسه ش میکنیم.
              const isEqual = sharedDataState.data.sizeTitle === singleRow.title;
              return <div
                key={index}
                className={isEqual ? "border bg-success text-bold rounded m-1 p-1" :
                  "border text-info text-bold rounded m-1 p-1"}
                style={{width: '100px', color: 'black'}}
                onClick={() => sizeClickHandler(singleRow.title)}

              >{singleRow.title}</div>
            })}
          </div>

          <ReactToPrint content={() => myRef.current}>
            <PrintContextConsumer>
              {({handlePrint}) => (<button className={"btn btn-danger"} onClick={handlePrint}>

                  <span>
                    چـــــاپ  &nbsp;
                  </span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={16}
                  height={16}
                  fill="currentColor"
                  className="bi bi-printer-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                  <path
                    d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                </svg>

              </button>)}
            </PrintContextConsumer>
          </ReactToPrint>
        </div>
        <div style={{"maxWidth": "80vw", "margin": "0 auto"}} className={"mt-3"}>
          <PrintDataComponent ref={myRef}
                              sharedDataState={sharedDataState}
                              widthHeightSizeFromSizeTitle={widthHeightSizeFromSizeTitle}
          />
        </div>
      </div>

    }
  </>);
};

export default Printer;
